// no conflict
var $ = jQuery.noConflict();

// =========================
// GLOBAL STATE
// =========================
let forceClose = false;
let activeItem = null;
let lockedItem = null;

$(document).ready(function () {
	let blackoutTimer;

	// =========================
	// BLACKOUT
	// =========================
	$(".blackout").on("mouseenter", function () {
		clearTimeout(blackoutTimer);

		blackoutTimer = setTimeout(() => {
			var els = document.querySelectorAll(".showSubMenu, .show-mega");

			els.forEach((el) => {
				el.classList.remove("showSubMenu", "show-mega");
			});

			$("header .chev_a a").removeClass("show-mega flip-arrow");
			$(".menu-responsive-wrap").removeClass("show active");
			$(".menu-responsive-wrap-search").removeClass("active");
			$(".blackout").removeClass("is-active");
			$("header").removeClass("dark-head");
		}, 300);
	});

	$(".chev_a, .mega_menu_toggle, .menu-responsive-wrap").on(
		"mouseenter",
		function () {
			clearTimeout(blackoutTimer);
		},
	);

	// =========================
	// MEGA MENU
	// =========================
	$(".mega_menu_toggle").click(function () {
		$(this).toggleClass("is-active");
		$(".mega-wrap").toggleClass("is-active");
		return false;
	});

	// =========================
	// MOBILE MENU ITEMS
	// =========================
	$(".menu-responsive .menu-item-has-children").click(function (e) {
		if (!$(this).hasClass("is-active")) {
			$(this).addClass("is-active");
			e.preventDefault();
		}
	});

	$(".mobile-nav .menu-item-has-children").append(
		'<span class="open-menu far fa-chevron-right"></span>',
	);

	// =========================
	// SUB MENU LEVEL HANDLING
	// =========================
	$(".open-menu").on("click", function () {
		var level1 = document.getElementsByClassName("level-1");

		if (level1.length > 0) {
			$(this).addClass("level-2-open");
			$(this).prev(".sub-menu").addClass("level-2");
			$(this).closest(".menu-item-has-children").addClass("level-2-hold");
		} else {
			$(this).addClass("level-1-open");
			$(this).prev(".sub-menu").addClass("level-1");
			$(this).closest(".menu-item-has-children").addClass("level-1-hold");
		}

		$(".navbar-toggler").addClass("hide-menu").removeClass("open-mobile-menu");

		$(".back-menu").addClass("show-back");
		$(this).siblings().addClass("is-active");
	});

	// =========================
	// NAV LINK
	// =========================
	$(".nav__link").click(function (e) {
		e.preventDefault();
		$(this).siblings().addClass("is-active");
	});

	// =========================
	// MEGA CLEANUP
	// =========================
	$(".chev_a").on("mouseenter", function () {
		$(".menu-responsive-wrap-search").removeClass("show-mega-search");
		$(".blackout-search").removeClass("is-active");
	});

	// =========================
	// CLOSE MENU BUTTON (FIXED)
	// =========================
	$(document).on("click", ".custom-menu-close", function (e) {
		e.preventDefault();

		const $item = $(this).closest(".has-submenu");

		// =========================
		// TEMPORARY LOCK (NOT PERMANENT RESET)
		// =========================
		forceClose = true;
		activeItem = null;

		// close menu state
		$("body").removeClass("menu-open");

		// close visuals ONLY (not structure)
		$(".showSubMenu, .show-mega").removeClass("showSubMenu show-mega");
		$(".mega-wrap").removeClass("is-active");
		$(".blackout").removeClass("is-active");

		// optional: close current item only
		$item.removeClass("is-active");

		// HARD hover prevention (short-lived)
		$item.addClass("no-hover-lock");

		setTimeout(() => {
			$item.removeClass("no-hover-lock");
			forceClose = false;
		}, 250);
	});

	// =========================
	// SCROLL NAV
	// =========================
	$(window).scroll(function () {
		var sc = $(window).scrollTop();

		if (sc > 100) {
			$("#navbar").addClass("sticky-nav");
		} else {
			$("#navbar").removeClass("sticky-nav");
		}
	});

	// =========================
	// SEARCH
	// =========================
	$("#close-btn").click(function () {
		$("#search-overlay").fadeOut();
		$("#search-btn").show();
		$("body").removeClass("search_active");
	});

	$("#search-btn").click(function () {
		$("#search-overlay").fadeIn();
		$("body").addClass("search_active");
	});

	// =========================
	// HEADER SCROLL
	// =========================
	const header = document.querySelector("header");

	window.addEventListener("scroll", () => {
		if (window.scrollY > 100) {
			header.classList.add("scrolled");
			document.body.classList.add("header-scrolled");
		} else {
			header.classList.remove("scrolled");
			document.body.classList.remove("header-scrolled");
		}
	});
});

// =========================
// LAST SECTION DETECTION
// =========================
document.addEventListener("DOMContentLoaded", () => {
	const sections = document.querySelectorAll("#main-content section");

	if (sections.length) {
		const lastSection = sections[sections.length - 1];
		lastSection.classList.add("last-section");
	}
});

// =========================
// SUBMENU HOVER CONTROL (FIXED)
// =========================
document.addEventListener("DOMContentLoaded", () => {
	const menuItems = document.querySelectorAll(".has-submenu");

	menuItems.forEach((item) => {
		const submenu = item.querySelector(".js-submenu");
		if (!submenu) return;

		item.addEventListener("mouseenter", () => {
			if (forceClose) return;
			if (lockedItem === item) return;

			activeItem = item;
			document.body.classList.add("menu-open");
		});

		item.addEventListener("mouseleave", () => {
			setTimeout(() => {
				if (activeItem === item) {
					document.body.classList.remove("menu-open");
					activeItem = null;
				}
			}, 100);
		});
	});

	//mob-show-filter
	$(".mob-show-filter").on("click", function () {
		$(".mb-filter").addClass("active-filter");
		$(this).toggleClass('hide-b');
		$(".hide-p-fil").addClass("hide-p");
	});

	$(".close-mob-filter").on("click", function () {
		$(".mb-filter").removeClass("active-filter"); 
		$(".mob-show-filter").removeClass("hide-b"); 
		$(".hide-p-fil").removeClass("hide-p");
	});
});
